import { useEffect, useMemo, useState } from 'react';
import { Chip } from '@mui/material';

const parseDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const computeRemainingMs = (fechaFin, serverNow, clientAt) => {
  const fin = parseDate(fechaFin);
  const server = parseDate(serverNow);
  if (!fin || !server) return 0;
  const skew = Date.now() - (clientAt || Date.now());
  return fin.getTime() - (server.getTime() + skew);
};

const formatRemain = (ms) => {
  if (ms <= 0) return '00:00';
  const total = Math.floor(ms / 1000);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n) => String(n).padStart(2, '0');
  if (h > 0) return `${pad(h)}:${pad(m)}:${pad(s)}`;
  return `${pad(m)}:${pad(s)}`;
};

export const AuctionCountdown = ({ fechaFin, serverNow, clientAt, onExpire }) => {
  const [nowTick, setNowTick] = useState(Date.now());
  const remain = useMemo(
    () => computeRemainingMs(fechaFin, serverNow, clientAt),
    [fechaFin, serverNow, clientAt, nowTick]
  );

  useEffect(() => {
    const id = setInterval(() => setNowTick(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (remain <= 0 && onExpire) {
      onExpire();
    }
  }, [remain, onExpire]);

  const minutes = remain / 60000;
  let color = 'default';
  if (remain <= 0) color = 'error';
  else if (minutes < 5) color = 'error';
  else if (minutes < 15) color = 'warning';

  const label = remain <= 0 ? 'Tiempo agotado' : formatRemain(remain);
  const ariaMinutes = Math.max(0, Math.ceil(remain / 1000 / 30) * 30);

  return (
    <Chip
      size="small"
      color={color}
      variant={minutes < 5 ? 'filled' : 'outlined'}
      label={label}
      aria-label={`Tiempo restante aproximado ${ariaMinutes} segundos`}
    />
  );
};
